import type {FootnoteMethods} from '../../../hooks/useFootnotes'

export interface FootnoteToggleProps {
  number: number
  onClick: FootnoteMethods['onFootnoteClick']
  onEnter: FootnoteMethods['onFootnoteEnter']
  onKeyDown: FootnoteMethods['onFootnoteKeyDown']
}

const defaultProps: Partial<FootnoteToggleProps> = {}

const FootnoteToggle: React.FC<FootnoteToggleProps> = props => {
  const initializedProps = {...defaultProps, ...props}
  const {number, onClick, onEnter, onKeyDown} = initializedProps

  return (
    // TODO: Improve accessibility
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    <sup
      className="Footnote-toggle"
      role="button"
      onClick={event => onClick(number, event)}
      onPointerEnter={event => onEnter(number, event)}
      onKeyDown={event => onKeyDown(number, event)}
    >
      {number}
    </sup>
  )
}

export default FootnoteToggle
